import { useContext } from "react"
import UserItem from '../Users/UserItem'
import GithubContext from "../../Context/Github/GithubContext"

function UserResults() {
  const {users, loading} = useContext(GithubContext)

//this is only for testing purpose
//   useEffect(() => {
//     fetchUsers()

//   }, [])

 
  if(!loading) {

    return (
        <div className="grid grid-cols-1 gap-8 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2">
            {users.map((user) => (
                <UserItem key={user.id} user={user}/>
            ))}
            </div>
    )
  } else {
    //if loading is true, return the following
    return <h3>Loading...</h3>
  }

  
}

export default UserResults
